import { TParsedAppPreviews } from 'models/parser.model'

export const isPreviewsEmpty = (previews?: TParsedAppPreviews): boolean => {
  if (!previews) return true

  return Object.values(previews).every((value) => !value?.length)
}
